// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__E5kDI {
    position: absolute;
    bottom: -11px;
    left: 0;
    width: 103% !important;
    /* background-color: blue; */
    z-index: 2;
    /* height: 100px !important; */
    height: 50vh;
    left: -2% !important;
    padding: 10px;

}

.styles_iconContainer__Pi-ks {
    overflow-y: auto;
    flex-wrap: wrap;
    height: calc(100% - 65px);
    box-sizing: border-box;

    scrollbar-width: 8px;
}

.styles_iconContainer__Pi-ks::-webkit-scrollbar {


    background: transparent;
    width: 10px;
}

.styles_iconContainer__Pi-ks::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 10px;
}

.styles_iconContainer__Pi-ks.styles_dark__9qllS::-webkit-scrollbar-thumb {
    background-color: #555;
    border-radius: 100px;
    height: 10px;
}

.styles_iconContainer__Pi-ks::-webkit-scrollbar-thumb {
    /* background: transparent; */
    /* width: 5px; */
    border-radius: 100px;
    height: 8px;
}

.styles_head__yUFCs {
    overflow-x: auto;
    overflow-y: hidden;
    box-sizing: border-box;
    width: 100%;
    scrollbar-width: 5px;
}

.styles_head__yUFCs::-webkit-scrollbar {

    background: transparent;
    width: 5px;
    height: 10px;
}

.styles_head__yUFCs::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 8px;
}

.styles_head__yUFCs.styles_dark__9qllS::-webkit-scrollbar-thumb {
    background-color: #555;
    border-radius: 100px;
    height: 5px;
}

.styles_head__yUFCs::-webkit-scrollbar-thumb {
    /* background: transparent; */
    /* width: 5px; */
    border-radius: 100px;
    height: 5px;
}

.styles_head__yUFCs>div {
    margin-left: 5px;
    margin-right: 5px;
    cursor: pointer;
}

/* .iconContainerW {
    scrollbar-color: #555 transparent;
}

.iconContainerD {
    scrollbar-color: #555555 transparent;
} */

.styles_container__E5kDI span {
    cursor: pointer;
    font-size: 25px;
    /* margin: 8px;
    width: 10px;
    height: 10px; */
}

.styles_space__6jCMl {
    height: 65px;
}

.styles_activeTab__fIFv- {
    border-bottom: 1px solid #999;
}

.styles_activeTab__fIFv- svg {
    fill: #000 !important;
}

.styles_unActiveTab__HnY5t svg {
    fill: #999 !important;

}


@media only screen and (max-width: 650px) {
    .styles_container__E5kDI {
        bottom: -61px;
    }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Emoji/styles.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,4BAA4B;IAC5B,UAAU;IACV,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;IACpB,aAAa;;AAEjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;;IAEtB,oBAAoB;AACxB;;AAEA;;;IAGI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,oBAAoB;AACxB;;AAEA;;IAEI,uBAAuB;IACvB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;;;;;GAMG;;AAEH;IACI,eAAe;IACf,eAAe;IACf;;mBAEe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;;AAEzB;;;AAGA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".container {\n    position: absolute;\n    bottom: -11px;\n    left: 0;\n    width: 103% !important;\n    /* background-color: blue; */\n    z-index: 2;\n    /* height: 100px !important; */\n    height: 50vh;\n    left: -2% !important;\n    padding: 10px;\n\n}\n\n.iconContainer {\n    overflow-y: auto;\n    flex-wrap: wrap;\n    height: calc(100% - 65px);\n    box-sizing: border-box;\n\n    scrollbar-width: 8px;\n}\n\n.iconContainer::-webkit-scrollbar {\n\n\n    background: transparent;\n    width: 10px;\n}\n\n.iconContainer::-webkit-scrollbar-thumb {\n    background-color: #e3e3e3;\n    border-radius: 100px;\n    height: 10px;\n}\n\n.iconContainer.dark::-webkit-scrollbar-thumb {\n    background-color: #555;\n    border-radius: 100px;\n    height: 10px;\n}\n\n.iconContainer::-webkit-scrollbar-thumb {\n    /* background: transparent; */\n    /* width: 5px; */\n    border-radius: 100px;\n    height: 8px;\n}\n\n.head {\n    overflow-x: auto;\n    overflow-y: hidden;\n    box-sizing: border-box;\n    width: 100%;\n    scrollbar-width: 5px;\n}\n\n.head::-webkit-scrollbar {\n\n    background: transparent;\n    width: 5px;\n    height: 10px;\n}\n\n.head::-webkit-scrollbar-thumb {\n    background-color: #e3e3e3;\n    border-radius: 100px;\n    height: 8px;\n}\n\n.head.dark::-webkit-scrollbar-thumb {\n    background-color: #555;\n    border-radius: 100px;\n    height: 5px;\n}\n\n.head::-webkit-scrollbar-thumb {\n    /* background: transparent; */\n    /* width: 5px; */\n    border-radius: 100px;\n    height: 5px;\n}\n\n.head>div {\n    margin-left: 5px;\n    margin-right: 5px;\n    cursor: pointer;\n}\n\n/* .iconContainerW {\n    scrollbar-color: #555 transparent;\n}\n\n.iconContainerD {\n    scrollbar-color: #555555 transparent;\n} */\n\n.container span {\n    cursor: pointer;\n    font-size: 25px;\n    /* margin: 8px;\n    width: 10px;\n    height: 10px; */\n}\n\n.space {\n    height: 65px;\n}\n\n.activeTab {\n    border-bottom: 1px solid #999;\n}\n\n.activeTab svg {\n    fill: #000 !important;\n}\n\n.unActiveTab svg {\n    fill: #999 !important;\n\n}\n\n\n@media only screen and (max-width: 650px) {\n    .container {\n        bottom: -61px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__E5kDI`,
	"iconContainer": `styles_iconContainer__Pi-ks`,
	"dark": `styles_dark__9qllS`,
	"head": `styles_head__yUFCs`,
	"space": `styles_space__6jCMl`,
	"activeTab": `styles_activeTab__fIFv-`,
	"unActiveTab": `styles_unActiveTab__HnY5t`
};
export default ___CSS_LOADER_EXPORT___;
